export class User {
    firstname ?= '';
    lastname ?= '';
    email ?= '';
    password ?= '';
    user_id ? = '';
    user_status ?= '';
    user_role_id ?= '';
}


// WEBPACK FOOTER //
// ./src/app/type/user.ts